import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import {
  // Link,
  Button
} from '@material-ui/core';

const Botao = (props) => {
  const {
    disabled,
    fullWidth,
    size,
    type,
    variant,
    onClick,
    children,
    classes,
    color
  } = props;
  return (
    <Button
      color={color !== undefined ? color : 'primary'}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size || 'large'}
      type={type || 'button'}
      variant={variant || 'contained'}
      onClick={onClick}
      className={classes}
    >
      {children}
    </Button>
  );
};

export default Botao;
